import React from "react";
import { Button, Card, Toast } from "react-bootstrap";
import { Account, KeyStorageUser, SettingsMessages, useAppDispatch } from "src/common";
import { accountActions } from "src/store";

type AllProps = {
  kss_user: KeyStorageUser;
  current_account?: Account;
}

// Description: Component to display a message when a web authentication key is created or changed.
function WebAuthKeyAddedComponent(props: AllProps) {
  const { kss_user, current_account } = props;
  const dispatch = useAppDispatch();

  function handleContinue() {
    if (!!current_account) {
      dispatch(accountActions.downgradeExpressAccountRequest({ keystorage_user: kss_user, current_account }));
    } else {
      dispatch(accountActions.claimCSExpressAccountRequest(kss_user));
    }
  };

  return <Card.Body>
    <h3>Authentication Key Added</h3>
    <p>Your Authentication Key is on for your account.</p>
    <p>Keep your key with you so you can always sign into PreVeil and be FedRAMP compliant.</p>
    <Toast bg="warning" className="d-inline-block mb-3 mt-2">
      <Toast.Body>
        {SettingsMessages.web_auth_warning}
      </Toast.Body>
    </Toast>
    <div className="btn-panel">
      <Button onClick={handleContinue}>Continue</Button>
    </div>
  </Card.Body>;
}

export default React.memo(WebAuthKeyAddedComponent);